export default __webpack_public_path__ + "static/media/zwerverSpinner.75a1eab2.gif";